<template>
  <div id="app">
    <main>
      <div class="grid-container">
        <Header />
        <TeamList @render-profile="renderProfile" />
        <Input @render-profile="renderProfile" />
        <router-view v-bind:key="componentKey" />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import TeamList from "./components/TeamList.vue";
import Input from "./components/Input.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    TeamList,
    Input,
    Footer
  },
  data() {
    return {
      componentKey: 0
    };
  },
  methods: {
    renderProfile() {
      this.componentKey += 1;
    }
  }
};
</script>

<style lang="scss">
@import "assets/scss/app.scss";
</style>
